import { GoogleAuthProvider } from 'firebase/auth';
import React, { useContext, useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { AuthContext } from '../../contexts/AuthProvider/AuthProvider';
import ClimbingBoxLoader from "react-spinners/ClipLoader";
import useTitle from './../../hooks/useTitle';

const Login = () => {
    const [loading, setLoading] = useState()
    const navigate = useNavigate()
    const location = useLocation()
    useTitle('Login')

    const from = location.state?.from?.pathname || '/';

    const [error, setError] = useState('')

    const { providerLogin, signIn } = useContext(AuthContext)

    const googleProvider = new GoogleAuthProvider()

    const handleGoogleSignIn = () => {
        providerLogin(googleProvider)
            .then(result => {
                const user = result.user;
                console.log(user);
                const currentUser = {
                    email: user.email
                }

                fetch('https://wildlife-photographer-server.vercel.app/jwt', {
                    method: 'POST',
                    headers: {
                        'content-type': 'application/json'
                    },
                    body: JSON.stringify(currentUser)
                })
                    .then(res => res.json())
                    .then(data => {
                        console.log(data);
                        localStorage.setItem('wildlifePhotographerToken', data.token)
                        navigate(from, { replace: true })
                    })
            })
            .catch(err => console.error(err))
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        const form = event.target;
        const email = form.email.value;
        const password = form.password.value;
        console.log(email, password);
        signIn(email, password)
            .then(result => {
                const user = result.user;
                console.log(user);
                form.reset();
                setError('')

                const currentUser = {
                    email: user.email
                }

                // get jwt token
                fetch('https://wildlife-photographer-server.vercel.app/jwt', {
                    method: 'POST',
                    headers: {
                        'content-type': 'application/json'
                    },
                    body: JSON.stringify(currentUser)
                })
                    .then(res => res.json())
                    .then(data => {
                        console.log(data);
                        localStorage.setItem('wildlifePhotographerToken', data.token)
                        navigate(from, { replace: true })
                    })

            })
            .catch(error => {
                console.error('error', error);
                setError(error.message)
            })

    }

    useEffect(() => {
        setLoading(true)
        setTimeout(() => {
            setLoading(false)
        }, 800)
    }, [])

    return (
        <div className='flex justify-center items-center'>

            {
                loading ?
                    <ClimbingBoxLoader
                        color={'#32A8B3'}
                        loading={loading}
                        size={50}
                    />
                    :

                    <div className='flex justify-center items-center pt-8 pb-8'>
                        <div className='flex flex-col max-w-md p-6 rounded-md sm:p-10 bg-gray-100 text-gray-900'>
                            <div className='mb-8 text-center'>
                                <h1 className='my-3 text-4xl font-bold'>Please Log in !</h1>
                                <p className='text-sm text-gray-400'>
                                    Sign in to access your account
                                </p>
                            </div>
                            <form
                                noValidate=''
                                action=''
                                className='space-y-6 ng-untouched ng-pristine ng-valid'
                                onSubmit={handleSubmit}
                            >
                                <div className='space-y-4'>
                                    <div>
                                        <label htmlFor='email' className='block mb-2 text-sm'>
                                            Email address
                                        </label>
                                        <input
                                            type='email'
                                            name='email'
                                            id='email'
                                            placeholder='Enter Your Email Here'
                                            className='w-full px-3 py-2 border rounded-md border-gray-300 focus:border-gray-900 bg-gray-200 text-gray-900'
                                            data-temp-mail-org='0'
                                            required
                                        />
                                    </div>
                                    <div>
                                        <div className='flex justify-between'>
                                            <label htmlFor='password' className='text-sm mb-2'>
                                                Password
                                            </label>
                                        </div>
                                        <input
                                            type='password'
                                            name='password'
                                            id='password'
                                            placeholder='*******'
                                            className='w-full px-3 py-2 border rounded-md border-gray-300 bg-gray-200 focus:border-gray-900 text-gray-900'
                                            required
                                        />
                                    </div>
                                </div>


                                {
                                    <span className='text-red-600'>{error}</span>
                                }

                                <div>
                                    <button
                                        type='submit'
                                        className='w-full px-8 py-3 font-semibold rounded-md bg-gray-900 hover:bg-gray-700 hover:text-white text-gray-100'
                                    >
                                        Log in
                                    </button>
                                </div>
                            </form>
                            <div className='space-y-1'>
                                <button className='text-xs hover:underline text-gray-400'>
                                    Forgot password?
                                </button>
                            </div>
                            <div className='flex items-center pt-4 space-x-1'>
                                <div className='flex-1 h-px sm:w-16 dark:bg-gray-700'></div>
                                <p className='px-3 text-sm dark:text-gray-400'>
                                    Login with social accounts
                                </p>
                                <div className='flex-1 h-px sm:w-16 dark:bg-gray-700'></div>
                            </div>
                            <div className='flex justify-center space-x-4'>
                                <button onClick={handleGoogleSignIn} aria-label='Log in with Google' className='p-3 rounded-sm'>
                                    <svg
                                        xmlns='http://www.w3.org/2000/svg'
                                        viewBox='0 0 32 32'
                                        className='w-5 h-5 fill-current'
                                    >
                                        <path d='M16.318 13.714v5.484h9.078c-0.37 2.354-2.745 6.901-9.078 6.901-5.458 0-9.917-4.521-9.917-10.099s4.458-10.099 9.917-10.099c3.109 0 5.193 1.318 6.38 2.464l4.339-4.182c-2.786-2.599-6.396-4.182-10.719-4.182-8.844 0-16 7.151-16 16s7.156 16 16 16c9.234 0 15.365-6.49 15.365-15.635 0-1.052-0.115-1.854-0.255-2.651z'></path>
                                    </svg>
                                </button>
                            </div>
                            <p className='px-6 text-sm text-center text-gray-400'>
                                Don't have an account yet?{' '}
                                <Link to='/signup' className='hover:underline text-gray-600'>
                                    Register
                                </Link>

                            </p>
                        </div>
                    </div>
            }
        </div>
    );
};

export default Login;